// Components
import languageDataService from "@scripts/pages/language/services/languageDataService";

// Language Select Functionality
class Language {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.initLanguageSelectOnChange();
    }

    initLanguageSelectOnChange() {
        const element = document.querySelector('.js-language-select');
        if (element) {
            
            element.addEventListener('change', (data) => {
                
                var selectedValue = element.options[element.selectedIndex].value || "";

                languageDataService 
                    .changeLanguage(selectedValue)
                    .then(() => {
                        window.location.reload();
                    })
                    .catch((error) => {
                        const hasLocation = error?.location?.length > 0;
                        window.location.href = hasLocation ? error.location : "/session/expired";
                    });
            });
        }
    }
}

// Startup
document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById("js-app-header");
    if (el) new Language(el);
});